// src/oura/newscan/markets.ts
//
// The markets a business found by what it sells (Online) can pick, in plain
// labels as shown and as written in a question ("the US", "Malaysia").
// `global` ("Any market") is a row's market, never one staff pick.

import type { ScanDraftMarket, ScanMarketCode } from "@service/aeo/scanDraftTypes";

/** The markets staff can pick, in the add select's order. `global` is never one. */
export const PICKABLE_MARKETS: ReadonlyArray<ScanDraftMarket> = [
    { code: "us", label: "the US" },
    { code: "sg", label: "Singapore" },
    { code: "au", label: "Australia" },
    { code: "uk", label: "the UK" },
    { code: "my", label: "Malaysia" },
];

/** No more than this many markets. */
export const MARKETS_MAX = 4;

/** A market by code, with its label as shown and written in a question. */
export function marketOf(code: string): ScanDraftMarket | null {
    return PICKABLE_MARKETS.find((m) => m.code === code) ?? null;
}

/** The market a country name stands for ("Malaysia" -> my), for the read's single `market`. */
export function marketFromName(name: string | null | undefined): ScanDraftMarket | null {
    const k = (name ?? "").trim().toLowerCase().replace(/^the\s+/, "");
    if (!k) return null;
    const alias: Record<string, ScanMarketCode> = {
        us: "us",
        usa: "us",
        "united states": "us",
        uk: "uk",
        "united kingdom": "uk",
        britain: "uk",
    };
    const code = alias[k] ?? PICKABLE_MARKETS.find((m) => m.label.toLowerCase().replace(/^the\s+/, "") === k)?.code;
    return code ? marketOf(code) : null;
}
